export const Empty = ({ isLoading, mode }) => {
    return (
        <div className="ptb-80 px-170 border-bg5 sm-mt-32">
            <div className="text-center main">
                <span className="curtains-icon curtains-icon-fav size-58" />
            </div>

            <div className="flex-column align-center text-center body-text3 mt-24 gap-12">
                {isLoading ? (
                    <span>Loading...</span>
                ) : (
                    mode === 'wishlist'
                        ? (<>
                            <div className="max-width-220">
                                You have no items in your Wishlist.
                            </div>
                            <div className="max-width-380">
                                Please browse our fabrics and click on the heart icon
                                next to each fabric to add fabrics to your Wishlist.
                            </div>
                            <div>
                                <a href="/fabric" className="underline">
                                    Browse Fabrics
                                </a>
                            </div>
                        </>)
                        : (<>
                            <div className='max-width-220'>You haven't viewed fabrics yet.</div>
                            <div>
                                <a href='/fabric' className='underline'>Browse Fabrics</a>
                            </div>
                        </>)
                )}
            </div>
        </div>
    )
}